import { UserRole } from 'utils/api/api';

export type StoreViewMode = 'list' | 'add' | 'edit';

export enum Language {
	RU = 'ru',
	EN = 'en',
	TT = 'tt',
}

export const UserRoleHuman: Record<
	Exclude<keyof typeof UserRole, 'Monitor'>,
	UserRole
> = {
	Accountant: UserRole.Accountant,
	Administrator: UserRole.Administrator,
	Advertiser: UserRole.Advertiser,
	MonitorOwner: UserRole.MonitorOwner,
};

export const UserRoleMessageId = Object.fromEntries(
	Object.entries(UserRoleHuman).map(([roleKey, role]) => [role, roleKey]),
);

export const REGISTER_USER_ROLES = [UserRole.Advertiser, UserRole.MonitorOwner];
